import { ReactElement } from "react";
import { shallowEqual, useSelector } from "react-redux";
import { Navigate } from "react-router-dom";
import { RootState } from "../../../../redux";
import { UserInfo } from "../../../../ui/models/userInfo";

export interface RequireRoleProps {
  roles: string[];
  children: ReactElement;
}

export default function RequireRole({ roles, children }: RequireRoleProps) {
  const authInfo = useSelector<RootState, UserInfo>(
    ({ auth }: any) => auth.info,
    shallowEqual
  );

  if (!authInfo || !roles.includes(authInfo.role)) {
    return <Navigate to="/" replace />;
  }

  return children;
}
